export default "__VITE_ASSET__Bshmd$uj__"